import React, { useState, useEffect } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import rapidex from '../images/rapidex.png';
import caixaAssistencia from '../images/caixa_assistencia.png';
import { useNavigate } from "react-router-dom";
import { getPropostasCpfCnpj } from "../componentes/api/DataApi";
import { useLocation } from "react-router-dom";
import Skeleton from 'react-loading-skeleton';

export default function PropostaPage() {
    const navigate = useNavigate();
    const location = useLocation()
    const params = new URLSearchParams(location.search)

    const [loading, setLoading] = useState(false);
    const [propostas, setPropostas] = useState();

    useEffect(() => {
        if (params && params.get("cpf") !== null) {
            setLoading(true);

            getPropostasCpfCnpj(params.get("cpf"), (response) => {
                setLoading(false);

                if (response && response.codigo === 0) {
                    setPropostas(response.vendas);                    
                }
            });
        }
        else {
            navigate("/pesquisa");
        }
    }, []);

    const onVoltar = () => {
        navigate("/pesquisa");
    }

    const onDetalhe = (id) => {
        navigate("/proposta_detalhe?id=" + id);
    }

    return (
        <>
            {loading &&
                <>
                    <div className="d-flex flex-column w-100 align-items-center">
                        <div className="d-flex flex-column bg-padrao align-items-center" style={{ width: "1150px" }}>
                            <div className="d-flex flex-column" style={{ width: "100%" }}>
                                <Skeleton count={40} height={"20px"} />
                            </div>
                        </div>
                    </div>
                </>
            }

            {!loading &&
                <>
                <div className="d-flex flex-column w-100 align-items-center h-full">
                    <div className="d-flex flex-column bg-padrao align-items-center h-full" style={{ width: "1150px" }}>
                        <div className="d-flex flex-row justify-content-between w-100">
                            <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                                <img src={rapidex} alt=""></img>
                            </div>
                            <img src={caixaAssistencia} alt=""></img>
                        </div>

                        <div className="d-flex flex-column align-items-center" style={{marginTop: '100px', width: '800px', border: "1px solid #aaa", marginBottom: "80px"}}>
                            <div className="d-flex flex-column" style={{width: '800px'}}>
                                <div className="d-flex flex-column tituloVenda w-100">
                                    PROPOSTAS
                                </div>
                            </div>

                            <div className="d-flex flex-column w-100">
                                <div className="d-flex flex-row justify-content-start flex-wrap" style={{padding: '10px 10px 10px 10px'}}>
                                    {propostas?.length > 0 ? 
                                        <>
                                        {propostas && propostas.map(proposta => {
                                            return (
                                                <div className="d-flex flex-column botaoNovaProposta" 
                                                    style={{padding: '10px 10px 10px 10px', margin: '2px 2px 2px 2px', cursor: "pointer"}} 
                                                    onClick={() => onDetalhe(proposta.id)}
                                                    key={proposta.id}>
                                                    <div>{proposta.produto}</div>
                                                    <div>{proposta.numProposta}</div>
                                                </div>
                                            )
                                        })}
                                        </>
                                    :
                                        <center><b>Não há proposta ativa para esse cliente!</b></center>
                                    }
                                </div>
                            </div>

                            <div className="d-flex flex-row" style={{marginBottom: "20px", marginTop: '40px'}}>
                                <button className="botaoPropostas" style={{cursor: "pointer"}} onClick={onVoltar}>VOLTAR</button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
            }
        </>
    )
}